import React from "react";
import PendingApplicationsRoleWise from "./PendingApplicationsRoleWise";

const DTDOPendingApplications = () => {
  return (
    <PendingApplicationsRoleWise
      status="7,8"
      title="DTDO Pending Applications Report"
      heading="DTDO Pending Applications"
      pageFrom="dtdo-pending-applications"
    ></PendingApplicationsRoleWise>
  );
};

export default DTDOPendingApplications;
